<template>
  <div class="stat-graphic-type-1">
    <div class="title">{{ title }}</div>
    <Grafico1Valore :value="valore" v-for="valore in valori.data" v-if="valori.data"/>
  </div>
</template>
<script>
  import ApiService from '@/services/api/ApiService.js';
  import Grafico1Valore from '@/components/elements/Grafico1Valore.vue';

  export default {
    name: 'grafico_tipo_1',
    props: ['module'],
    data() {
      return {
        valori: [],
      }
    },
    created() {
      this.title = this.module.data.attributes.titolo;
      ApiService.getRelationship(this.module.data.relationships.valori_grafico.links.related).then(relationship => {
        this.valori = relationship;
      })
        .catch(error => console.log('error on Aziende getRelationship: ', error))
        .finally(() => {
        });
    },
    components: {
      Grafico1Valore,
    }
  }
</script>
